export const dataSource = {
  "live": "Live Mode",
  "mock": "Mock Mode",
  "liveTooltip": "Data is being fetched from a live Supabase database.",
  "mockTooltip": "Displaying local mock data. No changes will be saved."
};
